"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _EqualSizeGridModule = _interopRequireDefault(require("./../../scss/layout-wrappers/EqualSizeGrid.module.scss"));
function EqualSizeGrid(_ref) {
  let {
    children,
    gap = '1.5rem',
    itemsPerRow = 4,
    classname = ''
  } = _ref;
  const childrenList = _react.Children.toArray(children);
  return /*#__PURE__*/_react.default.createElement("equal-size-grid", {
    style: {
      '--esg-gap-size': gap,
      '--esg-template-columns': "repeat(".concat(itemsPerRow, ", 1fr)")
    },
    "data-item-count": childrenList.length,
    class: classname
  }, childrenList.map(child => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _EqualSizeGridModule.default['equal-size-grid__item'],
      key: "esfr-".concat(Math.round(Math.random() * 10000000))
    }, /*#__PURE__*/(0, _react.cloneElement)(child, child.props));
  }));
}
var _default = exports.default = EqualSizeGrid;